export default "__VITE_ASSET__DOXMopSW__"